import React from "react";
import dmg from '../images/dmg.jpg'
import permissions1 from '../images/permissions1.jpg'
import permissions2 from '../images/permissions2.jpg'

const MacInstall = (props) => {
    const ref = React.useRef(null)

    React.useEffect(() => {
        setTimeout( ()=> ref.current.click(), 2000 ) 
    }, [])

  return (
    <main id='mac' style={{ textAlign: "justify", padding: '20px', maxWidth: '650px' }}>
        <a ref={ref} href="https://github.com/daniel97molina/WiMouseServer/releases/download/v.1.3/WiMouse.Server-1.3.1.dmg"></a>
      <h3 style={{marginTop: '100px', paddingLeft: 0}}>WiMouse Server will download automatically. <a href='https://github.com/daniel97molina/WiMouseServer/releases/download/v.1.3/WiMouse.Server-1.3.1.dmg'>Clic here to start download manually</a></h3>
      <h1 style={{padding: 0}}>Just a little setup on your mac</h1>
      <h3>Open the .dmg file and drag the WiMouse icon to the Applications folder:</h3>
    <img src={dmg} alt='open dmg file'></img>

    <h3>Clic on "Open System Preferences" when this promt is shown:</h3>
    <img src={permissions1} alt='open dmg file'></img>

    <h3>1. Clic on the lock icon and enter your password</h3>
    <h3>2. Check WiMouse Server</h3>
    <img src={permissions2} alt='open dmg file'></img>

    </main>
  );
};

export default MacInstall;
